<template>
  <div>
    <v-progress-linear indeterminate  v-if="linear && status"/>

    <v-overlay :absolute="absolute" 
               v-model="status"
               :opacity="opacity"
               :color="backgroundColor"
               :z-index="99999"
               v-else>
      <p class="text-center">
        <v-progress-circular
          indeterminate
          :size="size"
          :color="color"
        ></v-progress-circular>
      </p>
      <p class="text-h5 mt-5 text-center"
         v-if="$slots.default">
        <slot></slot>
      </p>
    </v-overlay>
  </div>
</template>

<style type="text/css" scoped>
   
</style>

<script>
  export default {
    name: 'Loading',

    mixins: [],

    data: () => ({
      
    }),

    props: {
      status: {
        default: false
      },
      size: {
        type: Number,
        default: 64
      },
      absolute: {
        type: Boolean,
        default: false
      },
      opacity: {
        type: Number,
        default: 0.46
      },
      color: {
        type: String,
        default: ''
      },
      backgroundColor: {
        type: String,
        default: '#212121'
      },
      linear: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      
    }
  }
</script>
